import {
  EXPERIMENTS_TRACK_EVENT_LOGIN_PAGE_VIEW,
  EXPERIMENTS_TRACK_EVENT_LOGIN_SUCCESS,
  experimentsTrackEvent,
} from '../experiments/eventTracking'

import { type LoginMethod } from './loginAfterLoggedIn'
import { type LoginOrigin } from './loginOrigin'

export const trackLoginPageView = (origin: LoginOrigin): void => {
  experimentsTrackEvent(EXPERIMENTS_TRACK_EVENT_LOGIN_PAGE_VIEW, {
    $opt_event_properties: { origin },
  })
}

export const trackLoginSuccess = (
  origin: LoginOrigin,
  method: LoginMethod,
): void => {
  experimentsTrackEvent(EXPERIMENTS_TRACK_EVENT_LOGIN_SUCCESS, {
    $opt_event_properties: { method, origin },
  })
}
